import React from "react";
import { Stack, Button, Paper } from "@mui/material";
import { CustomTypographyComponent } from "../text";
interface FallbackErrorComponentProps {
  error: any;
  componentStack?: any;
  resetErrorBoundary: any;
}

export const FallbackErrorComponent = ({
  componentStack,
  error,
  resetErrorBoundary,
}: FallbackErrorComponentProps) => (
  <Stack
    id="FallbackErrorComponent"
    spacing={2}
    alignItems="center"
    width="80%"
    padding={2}
  >
    <Paper>
      <Stack spacing={2} alignItems="center" width="100%" padding={2}>
        <CustomTypographyComponent>
          Something went wrong:
        </CustomTypographyComponent>
        <CustomTypographyComponent>{error.message}</CustomTypographyComponent>
        {componentStack && (
          <CustomTypographyComponent>
            {componentStack}
          </CustomTypographyComponent>
        )}
        <Button variant="contained" onClick={resetErrorBoundary}>
          Try again
        </Button>
      </Stack>
    </Paper>
  </Stack>
);

export default FallbackErrorComponent;
